/**
 * Helper function to get the appropriate Tailwind color class based on the color name
 * @param colorName - The name of the color (yellow, green, blue, purple)
 * @param shade - The shade of the color (200, 500, etc.)
 * @param type - The type of class (bg for background, border for border)
 * @returns The corresponding Tailwind class name
 */
export function getColorClass(colorName: string, shade: number, type: "bg" | "border" = "bg"): string {
    const colorMap: Record<string, Record<string, string>> = {
        bg: {
            yellow: `bg-yellow-${shade} dark:bg-yellow-${shade}`,
            green: `bg-green-${shade} dark:bg-green-${shade}`,
            blue: `bg-blue-${shade} dark:bg-blue-${shade}`,
            purple: `bg-purple-${shade} dark:bg-purple-${shade}`,
        },
        border: {
            yellow: `border-yellow-${shade} dark:border-yellow-${shade}`,
            green: `border-green-${shade} dark:border-green-${shade}`,
            blue: `border-blue-${shade} dark:border-blue-${shade}`,
            purple: `border-purple-${shade} dark:border-purple-${shade}`,
        }
    }

    return colorMap[type]?.[colorName] || `${type}-gray-${shade}`
}
